import { apiClientJSON } from "../apis/apiClient";
import * as endpoints from "../configs/endpoints";
import * as types from "../constants/actionTypes";
import { POST_METHOD, PUT_METHOD } from "../constants/apiMethods";

export const getRewardPrograms = (filter) => {
  return {
    endpoint: endpoints.queryRewardPrograms(),
    method: POST_METHOD,
    types: [
      types.GET_REWARD_PROGRAMS_REQUEST,
      types.GET_REWARD_PROGRAMS_SUCCESS,
      types.GET_REWARD_PROGRAMS_FAILURE,
    ],
    body: filter,
  };
};

export const createRewardProgram = (body) => {
  return {
    endpoint: endpoints.createRewardProgram(),
    method: POST_METHOD,
    types: [
      types.CREATE_REWARD_PROGRAM_REQUEST,
      types.CREATE_REWARD_PROGRAM_SUCCESS,
      types.CREATE_REWARD_PROGRAM_FAILURE,
    ],
    body,
  };
};

export const updateRewardProgram = (id, body) => {
  return {
    endpoint: endpoints.updateRewardProgram(id),
    method: PUT_METHOD,
    types: [
      types.UPDATE_REWARD_PROGRAM_REQUEST,
      types.UPDATE_REWARD_PROGRAM_SUCCESS,
      types.UPDATE_REWARD_PROGRAM_FAILURE,
    ],
    body,
  };
};

export const clearRewardProgram = () => {
  return {
    type: types.CLEAR_REWARD_PROGRAM,
  };
};

export const getRewardRules = (filter) => {
  return {
    endpoint: endpoints.queryRewardRules(),
    method: POST_METHOD,
    types: [
      types.GET_REWARD_RULES_REQUEST,
      types.GET_REWARD_RULES_SUCCESS,
      types.GET_REWARD_RULES_FAILURE,
    ],
    body: filter,
  };
};

export const createRewardRule = (body) => {
  return {
    endpoint: endpoints.createRewardRule(),
    method: POST_METHOD,
    types: [
      types.CREATE_REWARD_RULE_REQUEST,
      types.CREATE_REWARD_RULE_SUCCESS,
      types.CREATE_REWARD_RULE_FAILURE,
    ],
    body,
  };
};

export const updateRewardRule = (id, body) => {
  return {
    endpoint: endpoints.updateRewardRule(id),
    method: PUT_METHOD,
    types: [
      types.UPDATE_REWARD_RULE_REQUEST,
      types.UPDATE_REWARD_RULE_SUCCESS,
      types.UPDATE_REWARD_RULE_FAILURE,
    ],
    body,
  };
};

export const clearRewardRule = () => {
  return {
    type: types.CLEAR_REWARD_RULE,
  };
};

export const getRewardClaims = (filter) => {
  return {
    endpoint: endpoints.queryRewardClaims(),
    method: POST_METHOD,
    types: [
      types.GET_REWARD_CLAIMS_REQUEST,
      types.GET_REWARD_CLAIMS_SUCCESS,
      types.GET_REWARD_CLAIMS_FAILURE,
    ],
    body: filter,
  };
};

export const createRewardProgramWithRule =
  (programPayload, rulePayload) => async (dispatch) => {
    dispatch({ type: types.CREATE_REWARD_PROGRAM_REQUEST });

    try {
      const programResponse = await apiClientJSON.post(
        endpoints.createRewardProgram(),
        programPayload
      );
      const programId = programResponse.data.body.program.id;

      dispatch({
        type: types.CREATE_REWARD_PROGRAM_SUCCESS,
        result: programResponse.data,
      });

      dispatch({ type: types.CREATE_REWARD_RULE_REQUEST });

      const fullRulePayload = {
        ...rulePayload,
        reward_program_id: programId,
      };

      await apiClientJSON.post(endpoints.createRewardRule(), fullRulePayload);

      dispatch({ type: types.CREATE_REWARD_RULE_SUCCESS });

      return { success: true };
    } catch (error) {
      dispatch({ type: types.CREATE_REWARD_PROGRAM_FAILURE, error });
      return { success: false, error };
    }
  };

export const updateRewardProgramAsync =
  (programId, updatePayload) => async (dispatch) => {
    dispatch({ type: types.UPDATE_REWARD_PROGRAM_REQUEST });

    try {
      const response = await apiClientJSON.put(
        endpoints.updateRewardProgram(programId),
        { update: { set: updatePayload } }
      );

      dispatch({
        type: types.UPDATE_REWARD_PROGRAM_SUCCESS,
        result: response.data,
      });

      return { success: true };
    } catch (error) {
      dispatch({ type: types.UPDATE_REWARD_PROGRAM_FAILURE, error });
      return { success: false, error };
    }
  };
